/**
 * Maps top-level shopping category breadcrumb to a header image.
 *
 * Each image is imported so webpack/file-loader (via @buzzfeed/next-config +
 * next-images) emits a hashed CDN URL. Returning a bare `/static/...` path
 * works in dev (where the public folder is served directly) but 404s on
 * stage/prod where assets are served from the asset CDN.
 */

import buildingBlocks from '../public/static/images/shopping_header/building-blocks.png';
import dogCollar from '../public/static/images/shopping_header/dog-collar.png';
import dumbbell from '../public/static/images/shopping_header/dumbbell.png';
import gifts from '../public/static/images/shopping_header/gifts.png';
import home from '../public/static/images/shopping_header/home.png';
import laptop2 from '../public/static/images/shopping_header/laptop_2.png';
import mailbox from '../public/static/images/shopping_header/mailbox.png';
import peach from '../public/static/images/shopping_header/peach.png';
import sexToys from '../public/static/images/shopping_header/sex-toys.png';
import shoppingBag from '../public/static/images/shopping_header/shopping-bag.png';
import suitcase from '../public/static/images/shopping_header/suitcase.png';
import sweater2 from '../public/static/images/shopping_header/sweater-2.png';

export const DEFAULT_SHOPPING_HEADER_IMAGE = laptop2;

const CATEGORY_IMAGE_MAP = Object.freeze({
  'beauty-personal-care': sexToys,
  'fashion': sweater2,
  'gift-guide': gifts,
  'home': home,
  'sports-fitness': dumbbell,
  'stores': shoppingBag,
  'tech': laptop2,
  'kids': buildingBlocks,
  'pets': dogCollar,
  'subscriptions': mailbox,
  'sex-toys': peach,
  'travel': suitcase,
});

export function getShoppingHeaderImage(breadcrumbs = []) {
  const deepestCrumb = breadcrumbs[breadcrumbs.length - 1];
  const segments = deepestCrumb?.url?.split('/').filter(p => p && p !== 'shopping') ?? [];
  const primaryCategory = segments[0];

  return CATEGORY_IMAGE_MAP[primaryCategory] || DEFAULT_SHOPPING_HEADER_IMAGE;
}
